import appointmentService from './appointment.service';
import profileService from './profile.service';
import quoteService from './quote.service';
import clientReviewService from './clientReview.service';
import userService from './user.service';
import locationService from './location.service';
import ratingService from './rating.service';
import documentService from './document.service';
import requestService from './request.service';
import cabinetService from './cabinet.service';
import emailService from './email.service';
import skillsServices from './skills.service';
import activitiesServices from './activity.service';

const Services = {
  appointmentService,
  profileService,
  quoteService,
  clientReviewService,
  userService,
  locationService,
  ratingService,
  documentService,
  requestService,
  cabinetService,
  emailService,
  skillsServices,
  activitiesServices,
};

export default Services;
